const resolvePolicyPayload = (component, policy) => policy || component.policy || {};

const resolveCustomerId = (component, policyPayload) => {
  if (policyPayload?.customer?.id) {
    return policyPayload.customer.id;
  }

  if (policyPayload?.customer_id) {
    return policyPayload.customer_id;
  }

  return component?.$route?.params?.id || null;
};

const hasReadyCustomerContext = (policyPayload) => Boolean(policyPayload?.customer?.id && policyPayload?.customer?.team);

const ensureCustomerDetails = async (component, policyPayload) => {
  const initialCustomer = policyPayload?.customer || {};
  if (Object.keys(initialCustomer).length) {
    component.$store.commit("setCustomerDetails", initialCustomer);
  }

  const customerId = resolveCustomerId(component, policyPayload);
  if (!customerId || hasReadyCustomerContext(policyPayload)) {
    return;
  }

  try {
    await component.$store.dispatch("getGlobalCustomer", customerId);
    const fetchedCustomer = component.$store.getters.customer;

    if (fetchedCustomer?.id) {
      component.$store.commit("setCustomerDetails", fetchedCustomer);
    }
  } catch (error) {
    console.error("Unable to preload customer context for potential policy modal", error);
  }
};

const openPotentialPolicyModal = async (component, policy) => {
  const policyPayload = resolvePolicyPayload(component, policy);
  component.$store.commit("setPotentialPolicyToEdit", policyPayload);
  component.$store.commit("setShowAddPotentialPolicyModal", true);

  component.$store.commit("setPotentialPolicyModalLoading", true);
  ensureCustomerDetails(component, policyPayload).finally(() => {
    component.$store.commit("setPotentialPolicyModalLoading", false);
  });
};

const convertPotentialToPolicy = async (component, policy) => {
  const policyPayload = resolvePolicyPayload(component, policy);
  component.$store.commit("setPolicyIsConverting", true);
  component.$store.commit("setConvertingPolicyData", {
    id: policyPayload.id,
    agentId: policyPayload?.agent?.id || null,
    text: policyPayload.text,
  });
  component.$store.commit("setShowAddPolicyModal", true);

  component.$store.commit("setPolicyModalLoading", true);
  ensureCustomerDetails(component, policyPayload).finally(() => {
    component.$store.commit("setPolicyModalLoading", false);
  });
};

export { openPotentialPolicyModal, convertPotentialToPolicy };